module.exports = __webpack_public_path__ + "static/img/far1_active.e1769a84.png";